import OpeningHoursTable from 'components/Pages/StoreDetail/OpeningHoursTable/OpeningHoursTable';

export default OpeningHoursTable;
